/**
 * format params
 * @param {any} data 需要格式化的参数
 */
var formatParams = function(data) {
  var arr = [];
  for (var name_1 in data) {
    if (data.hasOwnProperty(name_1)) {
      arr.push(
        encodeURIComponent(name_1) + '=' + encodeURIComponent(data[name_1])
      );
    }
  }
  // add a timestamp to prevent cache
  arr.push('t=' + new Date().getTime());
  return arr.join('&');
};
/**
 * xhr响应结果json化
 * @param {any} respone xhr响应结果
 * @returns JSON
 */
var respone2Json = function(respone) {
  if (typeof respone === 'string') {
    try {
      return JSON.parse(respone);
    } catch (err) {
      console.error('json parse error, responeText = ', respone, err);
    }
  }
  return respone;
};
/**
 * ajax request, contain get and post
 * @param {string} url 请求url
 * @param {any} params 请求参数
 * @returns {Promise} Promise对象
 */
var ajax = function(url, params) {
  return new Promise(function(resolve, reject) {
    var type = params.type || 'GET';
    var data = formatParams(params.data || {});
    var jsonTimer = null;
    var timeout = params.timeout || 3000;
    var xhr = new XMLHttpRequest();
    if (!xhr) {
      throw new Error('you browser don not suppot XMLHttpRequest');
    }
    // 2022-07-31: 兼容IE，采用默认 responseType，即 TEXT
    // xhr.responseType = params.dataType || 'json';
    if (type === 'GET') {
      xhr.open('GET', url + '?' + data, true);
      xhr.send(null);
    } else {
      xhr.open('POST', url, true);
      xhr.setRequestHeader(
        'Content-Type',
        'application/x-www-form-urlencoded;charset=UTF-8'
      );
      xhr.send(data);
    }
    // listen readystatechange
    xhr.onreadystatechange = function() {
      if (xhr.readyState === 4) {
        jsonTimer && clearTimeout(jsonTimer);
        if (xhr.status >= 200 && xhr.status < 300) {
          return resolve(respone2Json(xhr.response));
        } else {
          return reject(xhr.status);
        }
      }
    };
    // timeout detroy
    jsonTimer = setTimeout(function() {
      xhr.abort();
      return reject('time out');
    }, timeout);
  });
};

var generateCB = function() {
  return 'jsonp' + Math.ceil(Math.random() * 10000000000);
};
var removeCB = function(name) {
  try {
    delete window[name];
  } catch (e) {
    window[name] = undefined;
  }
};
var createScript = function(url, id) {
  var script = document.createElement('script');
  script.setAttribute('src', url);
  script.id = id;
  document.getElementsByTagName('head')[0].appendChild(script);
};
var removeScipt = function(id) {
  var script = document.getElementById(id);
  script && script.parentNode && script.parentNode.removeChild(script);
};
/**
 * jsonp请求
 * @param {string} url - 请求url
 * @param {any} params - 参数
 * @example
 * const url = 'https://test.zhixue.com/container/rebuild/teacher/getResourceByTag';
 * const params = {
 *   data: {
 *      tag: 'zxTag'
 *   },
 *   timeout: '2000'
 * };
 * jsonp(url, params);
 * @returns {Promise} Promise
 */
var jsonp = function(url, params) {
  if (url === void 0) {
    url = '';
  }
  if (params === void 0) {
    params = {};
  }
  return new Promise(function(resolve, reject) {
    var jsonpTimer = null;
    var timeout = params['timeout'] || 3000;
    var cb = generateCB();
    var scriptId = cb;
    // splice param
    var data = params.data || {};
    data['callback'] = cb;
    var query = [];
    Object.keys(data).forEach(function(key) {
      query.push(encodeURIComponent(key) + '=' + encodeURIComponent(data[key]));
    });
    // register the callback function
    window[cb] = function(respone) {
      jsonpTimer && clearTimeout(jsonpTimer);
      resolve(respone);
      removeScipt(scriptId);
      removeCB(cb);
    };
    createScript(url + '?' + query.join('&'), scriptId);
    // timeout detroy
    jsonpTimer = setTimeout(function() {
      removeScipt(scriptId);
      removeCB(cb);
      reject('time out');
    }, timeout);
  });
};

var getEnv = function() {
  var DEV_ENV = 'development';
  try {
    if (process.env.NODE_ENV === DEV_ENV) {
      return true;
    }
    // eslint-disable-next-line no-empty
  } catch (e) {}
  if (
    window.location.hostname === 'localhost' ||
    window.location.href.indexOf('file') === 0
  ) {
    return true;
  }
  return false;
};

/**
 * http通信组件，自动根据环境使用jsonp或ajax
 * @param {string} url 请求url
 * @param {object} data 请求参数
 * @param {boolean} flag 制定方式 true => jsonp
 */
var http = function(url, data, flag) {
  if (typeof url !== 'string') {
    throw new Error('url must be type of string');
  }
  var params = {
    data: data
  };
  if (flag || getEnv()) {
    var reg = /^(http:|https:)?\/\//;
    if (!reg.test(url)) {
      url = 'https://test.zhixue.com' + url;
    }
    return jsonp(url, params);
  }
  return ajax(url, params);
};

export default http;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@zx/crosshttp/dist/crosshttp.js
// module id = null
// module chunks = 